import { useState } from "react";
import "@/App.css";

// Landing page components
import Header from "./components/landing/Header";
import HeroSection from "./components/landing/HeroSection";
import StatsBar from "./components/landing/StatsBar";
import ProblemSection from "./components/landing/ProblemSection";
import ForWhoSection from "./components/landing/ForWhoSection";
import HowItWorks from "./components/landing/HowItWorks";
import BenefitsSection from "./components/landing/BenefitsSection";
import ROICalculator from "./components/landing/ROICalculator";
import PricingSection from "./components/landing/PricingSection";
import FAQSection from "./components/landing/FAQSection";
import FinalCTA from "./components/landing/FinalCTA";
import Footer from "./components/landing/Footer";
import CheckoutModal from "./components/landing/CheckoutModal";
import MobileBottomBar from "./components/landing/MobileBottomBar";

function App() {
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [spotsLeft, setSpotsLeft] = useState(7);
  
  // Set deadline to 3 days from now
  const deadline = new Date();
  deadline.setDate(deadline.getDate() + 3);

  const handleCTAClick = () => {
    setIsCheckoutOpen(true);
  };

  return (
    <div className="App min-h-screen bg-[#FAFAF9]" data-testid="app-container">
      {/* Header */}
      <Header onCTAClick={handleCTAClick} />

      {/* Hero Section with Urgency Banner */}
      <HeroSection 
        onCTAClick={handleCTAClick} 
        spotsLeft={spotsLeft}
        deadline={deadline}
      />

      {/* Stats Marquee */}
      <StatsBar />

      {/* Problem Timeline */}
      <ProblemSection />

      {/* For Who Section */}
      <ForWhoSection />

      {/* How It Works */}
      <HowItWorks />

      {/* Benefits */}
      <BenefitsSection />

      {/* ROI Calculator */}
      <ROICalculator />

      {/* Pricing */}
      <PricingSection 
        onCTAClick={handleCTAClick}
        spotsLeft={spotsLeft}
      />

      {/* FAQ */}
      <FAQSection />

      {/* Final CTA */}
      <FinalCTA 
        onCTAClick={handleCTAClick}
        spotsLeft={spotsLeft}
      />

      {/* Footer */}
      <Footer />

      {/* Mobile Bottom Bar */}
      <MobileBottomBar 
        onCTAClick={handleCTAClick}
        spotsLeft={spotsLeft}
      />

      {/* Checkout Modal */}
      <CheckoutModal 
        isOpen={isCheckoutOpen}
        onClose={() => setIsCheckoutOpen(false)}
      />
    </div>
  );
}

export default App;
